import TeamContainer from './team_container';

const Team = TeamContainer;
export default Team;
